"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.StarIcon16Solid = forwardRef_1.forwardRef('StarIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M7.311.9A.75.75 0 0 1 8.69.9l1.764 4.096 4.442.412a.75.75 0 0 1 .425 1.31l-3.35 2.944.98 4.352a.75.75 0 0 1-1.115.81L8 12.545l-3.835 2.277a.75.75 0 0 1-1.115-.81l.98-4.35L.68 6.717a.75.75 0 0 1 .425-1.31l4.442-.412L7.31.899Z" })));
});
